module.exports = __webpack_public_path__ + "img/baoxian05.9979c121.png";